export const PAGE_URLS = {
  HOME: "/",
  TOKEN_DISTRIBUTOR: "/",
  CREATE_TOKEN_DISTRIBUTION: "/create",
  DISTRIBUTE_TOKENS: "/distribute",
  SHOPKEEPER: "/buy",
  REFERRAL: "/referral",
}
